import {combineReducers}             from "redux"
import RetrieveDecisionsAfterSaving  from "./RetrieveDecisionsAfterSaving"
import RetrieveV0UsageAfterSaving    from "./RetrieveV0UsageAfterSaving"


export default combineReducers({
  RetrieveDecisionsAfterSaving,
  RetrieveV0UsageAfterSaving,
})
